<template>
    <div class="businessCenter">
        <div class="banner_top">
            <img :src="this.sylbAddress" alt="" />
            <div class="content">
                <div>{{ headerMenus }}</div>
                <div>{{ serviceHotline }}：010-81215833</div>
            </div>
        </div>
        <div class="banner_bottom">
            <div class="product">
                <div class="product_head">
                    <div class="tag" v-for="(item, index) in productTagList" :key="item.menuId" @click="showInfos(item, index)"
                        :class="{ active: selected === item.menuId }"
                    >
                        {{ item.guideZw }}
                    </div>
                </div>
                <div class="product_list">
                    <!-- 产品详情 -->
                    <div class="product_details_content">
                        <div class="content_box" v-for="(ite, idx) in productList" :key="ite.productId" @click="showDialog(idx)">
                            <div class="content_img">
                                <img class="img" :src="ite.backup1" alt="" />
                            </div>
                            <div class="content_title">{{ ite.backup }}</div>
                            <div class="content_brief">{{ ite.productBrief }}</div>
                        </div>
                    </div>
                    <!-- 产品弹窗 -->
                    <!-- <el-dialog :title="productContent.backup" :visible.sync="dialogVisible">
                        <div class="ql-container ql-snow">
                            <div class="ql-editor" style="width:890px;">
                                <div v-html="productContent.content"></div>
                            </div>
                        </div>
                    </el-dialog> -->
                </div>
            </div>
        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
import vFooter from '../common/footer.vue';
import { gwGetMenuList, gwGetSYLBList, getGWProductInfoList, getGWProductInfoListById, getGWProductDetailById } from '@/api/index';
export default {
    name: 'businessArea',
    components: {
        vFooter
    },
    data() {
        return {
            headerMenus: '',
            serviceHotline: '',
            languageType: '1',
            fromDetailsId: null,
            sylbAddress: '',
            showInfosIndex: '0', // 产品导航默认index
            productTagList: [],
            productList: [],
            selected: null,
            dialogVisible: false,
            productContent: {},
            htmlText: ''
        };
    },
    watch: {
        $route(to, from){}
    },
    created() {
        if (sessionStorage.getItem('languageType')) {
            this.languageType = sessionStorage.getItem('languageType');
        }
        if (sessionStorage.getItem('showInfosIndex')) {
            this.fromDetailsId = sessionStorage.getItem('showInfosIndex')
        }
        this.gwGetMenuList(); // 标题 + 电话
        this.gwGetSYLBList(); // 标题背景图
        this.getGWProductInfoList();
        window.addEventListener('setItem', () => {
            this.languageType = sessionStorage.getItem('languageType');
            this.gwGetMenuList();
            this.getGWProductInfoList();
        });
    },
    methods: {
        gwGetMenuList() {
            let params = {
                language: this.languageType
            };
            gwGetMenuList(params).then((res) => {
                this.headerMenus = res.obj.menuList[2].guideZw,
                this.serviceHotline = res.obj.serviceHotline;
            });
        },
        gwGetSYLBList() {
            let params = {
                language: this.languageType,
                type: '3'
            };
            gwGetSYLBList(params).then(res => {
                this.sylbAddress = res.obj[0].sylbAddress
            });
        },
        // 产品导航菜单
        getGWProductInfoList() {
            let params = {
                language: this.languageType
            };
            getGWProductInfoList(params).then(res => {
                // console.log('查询全部产品导航', res.obj);
                this.productTagList = res.obj[0].gList
                if (this.fromDetailsId) {
                    this.selected = this.productTagList[this.fromDetailsId].menuId
                } else {
                    this.selected = this.productTagList[0].menuId
                }
                this.getGWProductInfoListById(this.selected)
            });
        },
        showInfos(row, index) { // 点击菜单切换数据
            this.selected = row.menuId;
            this.showInfosIndex = index;
            this.getGWProductInfoListById(row.menuId);
        },
        // 产品列表
        getGWProductInfoListById(menuId) {
            let params = {
                language: this.languageType,
                menuId: menuId
            };
            getGWProductInfoListById(params).then(res => {
                // console.log('根据ID查询产品', res.obj);
                this.productList = res.obj;
            });
        },
        // 产品详情
        getGWProductDetailById(id) {
            let params = {
                language: this.languageType,
                productId: id
            };
            getGWProductDetailById(params).then(res => {
                // console.log('根据ID查询产品详情', res.obj);
                this.productContent = res.obj;
            });
        },
        showDialog(idx) {
            sessionStorage.setItem('showInfosIndex', this.showInfosIndex);
            this.$router.push({
                path: '/productDetails',
                query: { showInfosIndex: this.showInfosIndex, idx: idx } // 产品导航index，产品内容index
            });
        },
    }
};
</script>

<style scoped lang="less">
@deep: ~'>>>';
.businessCenter {
    background-color: #fff;
    font-family: Source Han Sans;
    .banner_top {
        width: 100%;
        height: 4.95rem;
        margin: auto;
        // margin-bottom: -32px;
        overflow: hidden;
        position: relative;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
        }
        .content {
            color: #fff;
            position: absolute;
            top: 1.875rem; /* 距离顶部10像素 */
            left: 2.75rem; /* 距离左侧10像素 */
            padding: .125rem;
        }
        .content > div:nth-child(1) {
            font-size: .75rem;
            font-weight: 500;
            margin-bottom: .3rem;
        }
        .content > div:nth-child(2) {
            font-size: .35rem;
            font-weight: 400;
        }
    }
    .banner_bottom {
        margin: 0 3.25rem 1.25rem;
    }
    .product {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // align-items: center;
    }
    .product_head {
        width: 100%;
        text-align: left;
        display: flex;
        justify-content: center;
        margin: .75rem 0;
        .tag {
            min-width: 1.75rem;
            height: .375rem;
            padding: .125rem .375rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: .225rem;
            line-height: .3125rem;
            background: #f2f2f2;
        }
        .tag:hover {
            color: #fff;
            background: #023e7a;
            cursor: pointer;
        }
        .tag:first-of-type {
            border-radius: .075rem 0 0 .075rem;
        }
        .tag:last-of-type {
            border-radius: 0 .075rem .075rem 0;
        }
        .active {
            color: #fff;
            background: #023e7a;
        }
    }
    .product_list {
        // width: 960px;
        // height: 600px;
        margin: 0rem 0rem 0rem 0rem;
        padding: 0rem 0rem 0rem 0rem;
        background-color: #fff;
        overflow: hidden;
        zoom: 1;
        .product_details_content {
            padding: .1125rem;
            box-sizing: border-box;
            min-height: 5rem;
            // min-height: 600px;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: .8rem;
            flex-wrap: wrap;
            .content_box {
                border: .0125rem solid #f0f0f0;
                width: 23.5%; //23.93783%
                width: 3.5375rem;
                height: fit-content;
                position: relative;
                margin: .0625rem;
                padding: .125rem .125rem .075rem;
                overflow: hidden;
                // transition: all 0.3s ease 0s;
                box-sizing: border-box;
                .content_img {
                    overflow: hidden;
                    height: 3.125rem;
                    .img {
                        width: 100%;
                        height: 100%;
                        transition: all 0.6s ease-in-out;
                        transform: scale(1);
                        // object-fit: fill; // contain 保持原有比例；fill 默认 拉伸填充满
                        object-fit: contain;
                    }
                }
                .content_title,.content_brief {
                    width: auto;
                    margin: .25rem 0;
                    position: relative;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    text-align: center;
                    color: #000;
                }
                .content_title {
                    font-size: .25rem;
                    font-weight: bold;
                }
                .content_brief{
                    font-size: .1875rem;
                }
            }
            .content_box:hover{
                background: #fafafa;
                box-shadow: 0 0 .125rem #ddd;
                .img{transform: scale(1.1);}
            }
        }
    }
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard syntax */
}
</style>
